import { Box, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import OrderCardInfo from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/order-info-card';
import OrderProductsList from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/order-products-list';
import { ActiveOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

type Props = {
  order: ActiveOrder;
};

const StandardOrderRowBody: React.FC<Props> = ({ order }) => {
  return (
    <Box paddingBottom={4}>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} marginBottom={2}>
        <Box display={'flex'} flexDirection={'column'} gap={2} padding={2} width={'35%'}>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" sx={{}} fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.orderDetails`} />
            </Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" sx={{}} fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.vesselName`} />:
            </Typography>
            <Typography fontSize={14} whiteSpace={'nowrap'}>
              {order.vessel}
            </Typography>
          </Box>
          <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography variant="h6" fontWeight={'bold'} whiteSpace={'nowrap'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.plantName`} />:
            </Typography>
            <Typography fontSize={14} whiteSpace={'nowrap'}>
              {order.plantName}
            </Typography>
          </Box>
        </Box>

        <Box display={'flex'} flexDirection={'column'} width={'100%'} padding={2}>
          <OrderProductsList orderLines={order.orderLines} />
        </Box>
      </Box>
      <OrderCardInfo order={order} />
    </Box>
  );
};

export default React.memo(StandardOrderRowBody);
